import { Component, OnInit, Input } from '@angular/core';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-sky-nav',
  templateUrl: './sky-nav.component.html',
  styleUrls: ['./sky-nav.component.scss']
})
export class SkyNavComponent implements OnInit {

  @Input() scope;
  faEllipsisV = faEllipsisV;
  constructor() { }

  ngOnInit(): void {
  }

}
